import React, { InputHTMLAttributes } from "react";
import Checkbox from "@mui/material/Checkbox";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InteractionIntervalSetting from "../../../../../models/communications/InteractionIntervalSetting";
import { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useRowSelector, useStoreDispatch, useStoreSelector } from "../../../../../store/Hooks";
import { interactionTreeSliceActions } from "../../../../../store/slices/InteractionTreeSlice";
import InteractionNodeInterval from "../../../../../models/interactions/InteractionNodeInterval";
import useHttp from "../../../../../hooks/useHttp";
import {
  guidGenerator,
  interactionNodeIntervalsHandleFetch,
  stateDeepCopy,
} from "../../../../../helpers/DataUpdateHelper";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const InteractionIntervalSubscribeButton = (
  props: InteractionIntervalSetting,
) => {
  const [checked, setChecked] = useState(true);
  const { sendRequest: fetchData } = useHttp();

  const dispatch = useStoreDispatch();
  const interactionNodeIntervals = useStoreSelector(
    (state) => state.interactionTree.InteractionNodeIntervals,
  );

  const interactionNodeInterval = useRowSelector(InteractionNodeInterval, props.interaction_node_interval_id || 0);

  const handleChangeInteractionNodeIntervalSelect = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setChecked(event.target.checked);
    if (event.target.checked) {
      // add interaction_node_interval to redux, save to db
      save();
    } else {
      // remove interaction_node_interval from redux, delete from db
      removeInteractionNodeInterval();
    }
  };

  useEffect(() => {
    // set local state to controls' value
    setChecked(props.selected);
  }, [interactionNodeIntervals, props.selected]);

  let tooltipText = "Add interaction to interval";
  if (checked) {
    tooltipText = "Remove interaction from interval";
  }

  // uncheck
  // - delete corresponding interaction_node_interval in redux
  // do not save to db - save button must be clicked first!!!
  const removeInteractionNodeInterval = () => {
    dispatch(interactionTreeSliceActions.setInteractionNodeIntervalsToDelete({
      IntervalSetID:props.interval_set_id,
      append:true,
      InteractionNodeIntervalsToDelete:[interactionNodeInterval]
    }))
    interactionNodeInterval?.delete(false)
  };

  // handle "checked" icon
  // make new interaction_node_interval with temp id and mostly blank other fields
  // update db, then supply proper PK to redux obj
  const save = async () => {
    const newTempID = guidGenerator();
    const newInteractionNodeInterval = new InteractionNodeInterval(
      newTempID,
      props.interaction_node_id,
      props.interval_id,
      null,
      props.communication_set_id,
      "subject",
      "",
    );
    InteractionNodeInterval.fromJSON(newInteractionNodeInterval)

  };

  let dataTestID = "interactionIntervalSubscribeButtonUnchecked";
  if (checked) {
    dataTestID = "interactionIntervalSubscribeButton";
  }

  return (
    <Tooltip title={tooltipText}>
      <Checkbox
        // disabled={!props.editMode}
        data-testid={dataTestID}
        onChange={handleChangeInteractionNodeIntervalSelect}
        {...label}
        sx={{ "& .MuiSvgIcon-root": { fontSize: "25pt" } }}
        icon={<CheckCircleOutlineIcon />}
        inputProps={
          {
            "aria-label": "controlled",
            "data-testid": "clickableInteractionIntervalSubscribeButton",
          } as InputHTMLAttributes<HTMLInputElement>
        }
        checkedIcon={<CheckCircleIcon />}
        checked={checked}
        role="checkbox"
      />
    </Tooltip>
  );
};

export default InteractionIntervalSubscribeButton;
